import { AxiosResponse } from 'axios';
import api from './api';

export default {
  clinicalCareByUid(uid: string): Promise<AxiosResponse> {
    return api.get(`/clinical-cares/clinical-care-by-uid/${uid}`);
  },
  clinicalCareByProtocolNumber(protocolNumber: string): Promise<AxiosResponse> {
    return api.get(`/clinical-cares/clinical-care-by-protocol-number/${protocolNumber}`);
  },
};
